import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import chairman from "../Assets/Adirsory-Board/chairman-sir.jpg";
import sadhana from "../Assets/Adirsory-Board/sadhana-mam.jpg";
import david from "../Assets/Adirsory-Board/david-demarest.jpg";
import vivek from "../Assets/Adirsory-Board/vivek-tankha.jpg";
import pd_agrawal from "../Assets/Adirsory-Board/pd-agrawal.jpg";
import nirjhar from "../Assets/Adirsory-Board/rs-nirjhar.jpg";
import kothari from "../Assets/Adirsory-Board/dp-kothari.jpg";
import jacob from "../Assets/Adirsory-Board/pu-jacob.jpg";
import yutaka from "../Assets/Adirsory-Board/yutaka-yamaura.jpg";
import gaurav from "../Assets/Adirsory-Board/gaurav-ghelani.jpg";
import sunder from "../Assets/Adirsory-Board/sunder-rajan.jpg";
import satish from "../Assets/Adirsory-Board/satish-bal.jpg";
import pb_sharma from "../Assets/Adirsory-Board/p-b-sharma.jpg";
import sukul from "../Assets/Adirsory-Board/sukul-lomash.jpg";
import sergey from "../Assets/Adirsory-Board/sergey-panasenko.jpg";

const people = [
  {
    name: "Dr. Ramraj Karsoliya",
    img: chairman,
    des: "Chief Patron, B.Tech, M.Tech - IIT Kharagpur,Ph.D. - NIT Bhopal",
  },
  {
    name: "Mrs. Sadhana Karsoliya",
    img: sadhana,
    des: "Chairperson,EPWL - Stanford University, Graduate School of Business",
  },
  {
    name: "Mr. David Demarest",
    img: david,
    des: "Ex-White House Communication Director President George HW Bush, Ex-VP Stanford University, Ex-EVP Bank of America, Ex-EVP Visa",
  },
  {
    name: "Mr. Vivek Tankha",
    img: vivek,
    des: "Member of Parliament, Ex-Addl. Solicitor General of India",
  },
  {
    name: "Dr. D.P. Agrawal",
    img: pd_agrawal,
    des: "Ex-Chairman - Union Public Service Commission of India (UPSC)",
  },
  {
    name: "Dr. R.S. Nirjhar",
    img: nirjhar,
    des: "Ex-Chairman - All India Council of Technical Education (AICTE)",
  },
  {
    name: "Dr. D. P. Kothari",
    img: kothari,
    des: "Former Director, IIT Delhi",
  },
  {
    name: "Mr. P. U. Jacob",
    img: jacob,
    des: "Vice President, Hexaware",
  },
  {
    name: "Dr. Yutaka Tamaura",
    img: yutaka,
    des: "Ex-Director, Tokyo Institute of Technology",
  },
  {
    name: "Mr. Gaurav Ghelani",
    img: gaurav,
    des: "Regional Head - Campus Connect, TCS",
  },
  {
    name: "Mr. Sunder Rajan",
    img: sunder,
    des: "Ex-AVP, Hexaware",
  },  
  {
    name: "Dr. Satish Bal",
    img: satish,
    des: "Professor Emeritus, IIT Kharagpur",
  },
  {
    name: "Dr. P.B. Sharma",
    img: pb_sharma,
    des: "Founder VC,  Delhi Technological University",
  },
  {
    name: "Dr. Sukul Lomash",
    img: sukul,
    des: "Ex-Executive Director, BHEL",
  },
  {
    name: "Dr. Sergey Panasenko",
    img: sergey,
    des: "Chief Research Officer, Aktiv Co.  Moscow, Russia",
  },
];

const AdvisoryBoard = () => {
  const responsive = {
    superLargeDesktop: {
 
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div id="advisory" className="advisory">
      <h1>OUR ADVISORY BOARD</h1>
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay
        autoPlaySpeed={3000}
        keyBoardControl={true}
        transitionDuration={1000}
      >
        {people.map((d) => (
          <div className="advisory-hero">
            <div className="advisory-containor">
              <div className="advisory-img">
                <img src={d.img} alt="" />
              </div>
              <div className="advisory-des">
                <h2>{d.name}</h2>
                <p>{d.des}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
      ;
    </div>
  );
};

export default AdvisoryBoard;
